module.exports = __webpack_public_path__ + "img/trrafic-food-icon.041b55f2.svg";